export default {
    primary: 'primary',
    dtsPrimary: 'dts-primary',
    gray: 'gray',
    alt: 'alt',
    subdued: 'subdued',
    positive: 'positive',
    negative: 'negative',
    warning: 'warning',
    purple: 'purple',
};